import { createSelector } from 'reselect';
import { Map } from 'immutable';

const selectRequestHelp = (state) => state.get('requestHelp', Map());

const makeSelectRequestHelpResponse = () =>
  createSelector(selectRequestHelp, (state) => state.get('response'));

const makeSelectIsUserInvited = () =>
  createSelector(selectRequestHelp, (state) => state.get('isInvited'));

const makeSelectRequestHelpLoading = () =>
  createSelector(selectRequestHelp, (state) => state.getIn(['network', 'loading']));

export { makeSelectIsUserInvited, makeSelectRequestHelpResponse, makeSelectRequestHelpLoading };
